import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ButtonMaterial from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import palette from './styles/palette';

const useStyles = makeStyles({
  root: ({
    bgColor,
    bgColorDisabled,
    color,
    colorDisabled,
    border,
    opacityDisabled,
    disableBorder,
  }) => ({
    backgroundColor: bgColor,
    color,
    border,
    '&:hover': {
      backgroundColor: bgColor,
    },
    '&:disabled': {
      backgroundColor: bgColorDisabled || bgColor,
      color: colorDisabled || color,
      opacity: opacityDisabled || 1,
      border: disableBorder || border,
    },
  }),
  minWidthZero: {
    minWidth: 0,
  },
});

const Button = ({
  bgColor = 'inherit',
  bgColorDisabled,
  color = palette.typography.white.solid,
  border = 'none',
  disableBorder = 'none',
  colorDisabled,
  className,
  minWidthZero = false,
  opacityDisabled,
  ...props
}) => {
  const styles = useStyles({
    bgColor,
    bgColorDisabled,
    color,
    colorDisabled,
    border,
    disableBorder,
    opacityDisabled,
  });

  return (
    <ButtonMaterial
      variant="contained"
      color="primary"
      className={clsx(className, styles.root, {
        [styles.minWidthZero]: minWidthZero,
      })}
      {...props}
    />
  );
};

Button.muiName = ButtonMaterial.muiName;

Button.propTypes = {
  nativeColor: PropTypes.string,
  minWidthZero: PropTypes.bool,
  ...ButtonMaterial.propTypes,
};

export default memo(Button);
